var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCandidatePhone(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.402 8.998C7.52247 9.05333 7.6582 9.06597 7.78682 9.03384C7.91544 9.00171 8.02928 8.92673 8.10958 8.82125L8.31667 8.55C8.42534 8.40511 8.56625 8.2875 8.72825 8.2065C8.89025 8.1255 9.06888 8.08333 9.25 8.08333H11C11.3094 8.08333 11.6062 8.20625 11.825 8.42504C12.0438 8.64384 12.1667 8.94058 12.1667 9.25V11C12.1667 11.3094 12.0438 11.6062 11.825 11.825C11.6062 12.0438 11.3094 12.1667 11 12.1667C8.21523 12.1667 5.54451 11.0604 3.57538 9.09129C1.60625 7.12216 0.5 4.45144 0.5 1.66667C0.5 1.35725 0.622916 1.0605 0.841709 0.841709C1.0605 0.622916 1.35725 0.5 1.66667 0.5H3.41667C3.72609 0.5 4.02283 0.622916 4.24162 0.841709C4.46042 1.0605 4.58333 1.35725 4.58333 1.66667V3.41667C4.58333 3.59779 4.54116 3.77642 4.46017 3.93842C4.37917 4.10041 4.26156 4.24133 4.11667 4.35L3.84367 4.55475C3.73658 4.63652 3.6611 4.75284 3.63004 4.88395C3.59899 5.01507 3.61429 5.15289 3.67333 5.274C4.47056 6.89326 5.78175 8.2028 7.402 8.998Z",
    stroke: "#485468",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCandidatePhone);
export default __webpack_public_path__ + "static/media/candidatePhone.fcb57100db929a3e3ac2fa2b52847b57.svg";
export { ForwardRef as ReactComponent };